{
  "global": {
    "overview": "Aperçu",
    "ua": "UC",
    "usd": "USD"
  },
  "nav": {
    "adfcycles": "Cycles du FAD",
    "afawa": "Afawa",
    "afdb": "Groupe de la Banque africaine de développement",
    "by_adfcycles": "Par Cycles du FAD",
    "by_country": "Par Pays & Région",
    "by_current_status": "Par Statut Actuel",
    "by_financing": "Par Sources de Financement",
    "by_high5": "Par High 5",
    "by_media": "Par Média",
    "by_project_type": "Par Type de Projet",
    "by_sector": "Par Secteur",
    "by_sovereign": "Souverain / Non Souverain",
    "by_status": "Par Statut",
    "by_year_type": "Par Événement du Projet",
    "by_year": "Par un ou plusieurs ans",
    "clear_filters": "Effacer les filtres",
    "countries": "Pays & Région",
    "demo": "Il s'agit d'un site de démonstration en cours de développement",
    "done": "Fait",
    "filters": "Filtres",
    "financing": "Sources de Financement",
    "green_bond": "Obligation durable",
    "has_document": "Document",
    "has_story": "Histoire",
    "high5s": "High 5s",
    "home": "Accueil",
    "in": "en",
    "mapafrica": "MapAfrica",
    "non_sovereign": "Non souverain",
    "projects": "Projets",
    "results": "Résultats",
    "search": "Recherche",
    "sectors": "Secteurs",
    "social_bond": "Obligation sociale",
    "sovereign": "Souverain",
    "status_approved": "Approuvé",
    "status_cancelled": "Annulé",
    "status_completed": "Achevé",
    "status_ongoing": "En cours",
    "year_type_approved": "Approuvé",
    "year_type_completed": "Achevé",
    "year_type_planned": "Prévue d'achèvement",
    "year_type_signed": "Signé"
  },
  "locale": {
    "en": "English",
    "fr": "Français"
  },
  "home": {
    "approval_date": "Date d'approbation",
    "commitment": "Engagement",
    "csv": "CSV",
    "description": "Explorez les activités financées par la Banque africaine de développement",
    "download": "Exporter des données",
    "end_date": "Date de fin",
    "iati_identifier": "Identifiant IATI",
    "identifier": "Code projet",
    "json": "JSON",
    "map_title": "Carte de tous les projets",
    "multinational": "Multinational",
    "none_selected": "Aucun sélectionné",
    "projects": "Projets",
    "project_title": "Titre",
    "project_country": "Pays",
    "sector": "Secteur",
    "sovereign_non": "Souverain / Non Souverain",
    "status": "Statut",
    "title": "Aperçu",
    "unknown": "Inconnu",
    "xlsx": "XLSX",
    "xml": "XML"
  },
  "map": {
    "approved": "Approuvé",
    "at": "à",
    "commitment": "Engagement",
    "download": "Télécharger l'image",
    "generated_on": "Généré le",
    "generating": "Génération en cours...",
    "legend": "Légende de la carte",
    "multiple_themes": "Thèmes multiples",
    "print": "Imprimer",
    "project": "projet",
    "projects": "projets",
    "reset": "Réinitialiser",
    "sector": "Secteur",
    "status": "Statut"
  },
  "stats": {
    "projects": "Nombre de Projets",
    "status_approved": "Approuvé",
    "status_cancelled": "Annulé",
    "status_completed": "Achevé",
    "status_ongoing": "En cours",
    "total_commitments": "Total des Engagements",
    "total_country": "Spécifique au pays",
    "total_multi": "Portefeuille multinational"
  },
  "middle": {
    "in_million_ua": "en millions d'UC",
    "in_million_usd": "en millions d'USD",
    "multinational": "Multinational",
    "top_countries": "Pays",
    "top_sectors": "Secteurs",
    "top_sources": "Principales Sources de Financement",
    "top_themes": "High 5s",
    "unknown": "Inconnu"
  },
  "countries": {
    "description": "Explorez les activités financées par la Banque africaine de développement en {country}",
    "documents": "Documents",
    "map_title_countries": "Carte des projets par pays",
    "map_title_regions": "Carte des projets par région"
  },
  "sectors": {
    "description": "Explorez les activités financées par la Banque africaine de développement dans le secteur {sector}",
    "map_title": "Carte des projets par secteur"
  },
  "results": {
    "country": "Pays",
    "delivered": "Actuel",
    "expected": "Prévu",
    "high_5": "High 5",
    "indicator_name": "Nom de l'indicateur",
    "results_management_framework": "Cadre de Gestion des Résultats",
    "sector": "Secteur",
    "of": "de",
    "nav": {
      "results": "Résultats",
      "delivered2024": "Résultats réalisés en 2024",
      "tys": "Suivi de la stratégie décennale",
      "historical": "Résultats réalisés 2011-2025",
      "m300": "M-300"
    },
    "documents": {
      "rmf": "Cadre de Gestion des Résultats",
      "ader": "Revues annuelles sur l'efficacité du développement",
      "cder": "Revues sur l'Efficacité du développement - pays",
      "tder": "Revues sur l'Efficacité du développement - thématiques"
    },
    "countries": "Pays",
    "projects": "Projets",
    "project": "Projet",
    "years": "Années",
    "top5Countries": "Les 5 premiers pays",
    "showingDataFor": "Voir les résultats pour",
    "fromTo": " – ",
    "byYear": "Par an",
    "viewDetails": "Voir les détails →"
  },
  "m300": {
    "supplySystem": "Système d'approvisionnement",
    "connectionType": "Type de connexion",
    "indicator": "Indicateur",
    "m300Indicators": "Indicateurs M-300",
    "totalProjects": "Nombre total de projets",
    "progress": "Progrès",
    "delivered": "Livré",
    "target": "Cible",
    "underImplementation": "En cours de mise en œuvre",
    "remaining": "Restant",
    "additionalIndicators": "Indicateurs supplémentaires (projets achevés depuis 2015)",
    "projectLocations": "Emplacements des projets",
    "peopleProvidedWithAccessToElectricity": "Personnes ayant accès à l'électricité",
    "byRegion": "Par région :",
    "byCountry": "Par pays :",
    "projects": "Projets",
    "total": "Total",
    "onGrid": "Raccordés au réseau",
    "offGrid": "Non raccordés au réseau",
    "miniGrid": "Mini-réseaux",
    "households": "Ménages",
    "businesses": "Entreprises",
    "publicServices": "Services publics",
    "noData": "Aucune donnée n’est disponible pour les filtres sélectionnés.",
    "metrics": {
      "peopleProvided": {
        "delivered": "Personnes ayant désormais accès à l'électricité",
        "expected": "Personnes devant être raccordées"
      },
      "numberConnections": {
        "delivered": "Nombre de raccordements électriques",
        "expected": "Nombre supplémentaire de raccordements électriques prévus"
      },
      "powerCapacityInstalled": {
        "delivered": "Capacité électrique installée (MW)",
        "expected": "Capacité électrique supplémentaire prévue (MW)"
      },
      "transmissionLines": {
        "delivered": "Lignes de transport transfrontalières et nationales (KM)",
        "expected": "Lignes de transport supplémentaires prévues (KM)"
      },
      "distributionLines": {
        "delivered": "Lignes de distribution d'électricité nouvelles ou améliorées (km)",
        "expected": "Lignes de distribution d'électricité nouvelles ou améliorées prévues (km)"
      }
    },
  },
  "tys": {
    "expected_since_2024": "Résultats attendus des approbations depuis 2024",
    "target_2033": "Cible 2033",
    "ambition": "Niveau d'ambition envisagé 2033",
    "ambition_subtitle": "Ensemble des résultats escomptés des REP approuvés en 2024-2033",
    "legend_text": "Résultats attendus des approbations de 2024:",
    "on_track": "En bonne voie",
    "off_track": "Pas sur la bonne voie",
    "millions": "Millions"
  },
  "projects": {
    "adf_cycle": "Cycle du FAD",
    "afawa": "Afawa",
    "aid_type": "Type d'aide",
    "approval_date": "Date d'approbation",
    "beneficiaries": "Bénéficiaires",
    "climate_safeguards_cat": "Catégorisation des mesures de sauvegarde climatique",
    "commitment": "Engagement",
    "commitments": "Engagements",
    "contact_details": "Coordonnées",
    "country": "Pays",
    "dac_sector_code": "Code du secteur DAC",
    "date": "Date",
    "disbursement": "Décaissement",
    "disbursements": "Décaissements",
    "docs_1": "Rapport d'évaluation",
    "docs_2": "Contrat",
    "docs_3": "Évaluation environnementale et sociale",
    "docs_4": "Rapports sur l'état d'exécution et sur les résultats",
    "docs_5": "Acquisitions de biens et services relatives aux projets",
    "docs_6": "Protocole d'accord",
    "docs_7": "Rapport d'achèvement de projet",
    "documents": "Documents",
    "email": "Courriel",
    "end_date": "Date de fin",
    "environmental_cat": "Catégorie environnementale",
    "export": "Exportation",
    "finance_id": "ID du Type de Financement",
    "finance_type": "Type de financement",
    "financial_information": "Informations financières",
    "flow_type": "Type de flux",
    "fragility_lens_assessment": "Évaluation de la lentille de fragilité",
    "gender_marker_system_cat": "Catégorisation des systèmes de marqueurs de genre",
    "green_bond": "Obligation durable",
    "geographic_location": "Situation géographique",
    "iati_identifier": "Identifiant IATI",
    "indicator": "Indicateur",
    "indicator_actual": "Valeur Actuelle",
    "indicator_actual_year": "Année Actuelle",
    "indicator_measure": "Indicateur Mesure",
    "indicator_target": "Valeur Cible",
    "indicator_target_year": "Année Cible",
    "indicator_title": "Notes",
    "info": "Informations",
    "interest": "Paiements d'intérêts",
    "last_disbursement": "Date du rapport d'achèvement du projet",
    "loading": "Chargement...",
    "loans": "Remboursements de prêts",
    "location": "Emplacement",
    "name": "Nom",
    "no_results": "Aucun résultat",
    "non_sovereign": "Non souverain",
    "overview": "Aperçu",
    "participating_org": "Organisations participantes",
    "planned": "prévue",
    "project_classification": "Classification du projet",
    "planned_completion_date": "Date d'achèvement prévue",
    "project_general_description": "Description générale du projet",
    "project_objectives": "Objectifs du projet",
    "project_search": "Recherche de projets",
    "project_summary": "Résumé du projet",
    "project_type": "Type de Projet",
    "provider": "Fournisseur",
    "results": "Résultats",
    "search": "Recherche",
    "search_for_project": "Rechercher un projet",
    "search_results": "Résultats de la Recherche",
    "sector": "Secteur",
    "signature_date": "Date de signature",
    "social_bond": "Obligation sociale",
    "sovereign": "Souverain",
    "sovereign_non_sovereign": "Souverain / Non Souverain",
    "start_date": "Date de début",
    "status": "Statut",
    "stories": "Histoires",
    "theme": "High 5",
    "topics": "Thèmes",
    "totals": "Totaux",
    "unknown": "Inconnu",
    "untitled": "Sans titre",
    "value": "Valeur"

  },
  "footer": {
    "afdb": "Groupe de la Banque africaine de développement",
    "disclosure_1": "Diffusion et accès à l'information",
    "disclosure_2": "Mécanisme Indépendant de Recours",
    "disclosure_3": "À propos de ces données",
    "disclosure_html_1": "Avez-vous des préoccupations concernant un projet financé par la Banque ? Les personnes, travailleurs et les communautés qui sont (ou peuvent être) affectés négativement par les projets financés par la Banque africaine de développement (BAD) sont encouragés à contacter le mécanisme de règlement des griefs au niveau du projet ou à soumettre leurs plaintes au",
    "disclosure_html_2": "Mécanisme Indépendant de Recours (MIR)",
    "disclosure_html_3": "La politique de",
    "disclosure_html_4": "Diffusion et d'Accès à l'Information (DAI)",
    "disclosure_html_5": "est une réaffirmation de l'engagement du Groupe de la Banque à mener ses activités de développement de manière ouverte et transparente. La politique repose sur les principes de bonne gouvernance, en particulier la transparence, la responsabilité et le partage d'informations dans ses opérations. Elle établit les exigences de divulgation pour les documents et les informations produits ou requis par la BAD",
    "disclosure_html_6": "Les conversions en USD sont basées sur les taux de change du FMI à la fin du mois correspondant à la date de valeur.",
    "disclosure_html_7": "Données disponibles sous licence",
    "disclosure_html_8": "Creative Commons Attribution",
    "disclosure_html_9": "",
    "disclosure_url_1": "https://irm.afdb.org/fr",
    "disclosure_url_2": "https://www.afdb.org/fr/politique-de-diffusion-et-dacces-linformation-dai",
    "disclosure_url_3": "https://creativecommons.org/licenses/by/4.0/deed.fr",
    "glossary": "Glossaire",
    "rss": "Flux RSS",
    "sitemap": "Plan du site",
    "terms": "Conditions générales d'utilisation",
    "timestamp": "Dernière mise à jour"
  }
}
